import Badge from '@components/std-components/Badge'
import Icon from '@components/std-components/Icons'
import PopupComponent, { IPopupProps } from '@components/std-components/Popup'
import { ResizeIcon } from '@components/UI-Components/svg'
import { UserPreference } from '@stores/userPreferencesStore'
import '@styles/Icon/size-one-icons.css'
import React, { FC } from 'react'
import { CardSizeSelectorPopupContent } from './CardSizeSelectorPopupContent'
import { CardSizePopOverContentProps } from './CardSizeSelectorPopupContent/CardSizeSelectorPopupContent'
import Tooltip from '@material-ui/core/Tooltip'
import { useTranslation } from 'react-i18next'
import { CardSizeIcon } from '@core'

export const getConfig = (preference: UserPreference, enumObj: any, t: any) => ({
  [preference]: {
    label:
      preference === 'lookbookCard'
        ? t('common.label.lookbookCard', 'Look Cards')
        : t('common.label.productCard', 'Product Cards'),
    values: Object.values(enumObj)
  }
})

export const CardSizeSelectorPopup: FC<{
  popupProps: IPopupProps
  actionProps: CardSizePopOverContentProps
}> = ({ popupProps, actionProps }) => {
  const { t } = useTranslation()
  const { isEnhancedViewEnabled } = actionProps
  return (
    <PopupComponent
      trigger={
        <div>
          <Tooltip title={t('common.label.selectCardSize', 'Adjust cards size')}>
            <Badge color='primary'>
              {isEnhancedViewEnabled ? (
                <CardSizeIcon />
              ) : (
                <Icon imageSrc={ResizeIcon} alt={'resize'} />
              )}
            </Badge>
          </Tooltip>
        </div>
      }
      {...popupProps}
    >
      <CardSizeSelectorPopupContent {...actionProps} />
    </PopupComponent>
  )
}
